__turbopack_context__.v({
  "taskCreateDrawer": "G5nHaq_taskCreateDrawer",
  "taskCreateDrawer__body": "G5nHaq_taskCreateDrawer__body",
  "taskCreateDrawer__checkboxWrap": "G5nHaq_taskCreateDrawer__checkboxWrap",
  "taskCreateDrawer__closeButton": "G5nHaq_taskCreateDrawer__closeButton",
  "taskCreateDrawer__dateStatusRow": "G5nHaq_taskCreateDrawer__dateStatusRow",
  "taskCreateDrawer__error": "G5nHaq_taskCreateDrawer__error",
  "taskCreateDrawer__eyebrow": "G5nHaq_taskCreateDrawer__eyebrow",
  "taskCreateDrawer__footer": "G5nHaq_taskCreateDrawer__footer",
  "taskCreateDrawer__footerActions": "G5nHaq_taskCreateDrawer__footerActions",
  "taskCreateDrawer__header": "G5nHaq_taskCreateDrawer__header",
  "taskCreateDrawer__headerCopy": "G5nHaq_taskCreateDrawer__headerCopy",
  "taskCreateDrawer__row": "G5nHaq_taskCreateDrawer__row",
  "taskCreateDrawer__rowSingle": "G5nHaq_taskCreateDrawer__rowSingle",
  "taskCreateDrawer__section": "G5nHaq_taskCreateDrawer__section",
  "taskCreateDrawer__sectionTitle": "G5nHaq_taskCreateDrawer__sectionTitle",
  "taskCreateDrawer__title": "G5nHaq_taskCreateDrawer__title",
});
